<template>
    <div class="full-width" ref="mycardBanner">
        <div :class="bannerWidth < 768 ? 'angle-part-div-mobile left-angle-mobile' : 'angle-part-div left-angle'" v-show="showPrevArrow === true" @click="prevCard">
            <font-awesome-icon icon="fa-solid fa-chevron-left" beat-fade />
        </div>

        <div :class="bannerWidth < 768 ? 'card-div-mobile' : 'card-div'" :style="{height: cardHeight}" @click="clickCardImg">
            <cardFace :htmlText="cardHtml" :webmem="cardAuth" :scaleWidth="scaleWidth" :leftDistance="leftDistance" @scalePercent="changePercent"/>
        </div>

        <div :class="bannerWidth < 768 ? 'angle-part-div-mobile right-angle-mobile' : 'angle-part-div right-angle'" v-show="showNextArrow === true" @click="nextCard">
            <font-awesome-icon icon="fa-solid fa-chevron-right" beat-fade />
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, onUnmounted, ref, computed, watch, inject} from "vue";
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
    import cardFace from '@/components/cardFace'
    import myUtil from "@/util/util";

    library.add(faChevronLeft, faChevronRight)

    const props = defineProps(['cardIndex', "cardList"])
    const emits = defineEmits(['changeIndex'])

    const bannerWidth = ref(375)

    const { goCardView } = inject('phoneView', { goCardView: () => { goCardPage() } })

    const { proxy } = getCurrentInstance()

    const scaleWidth = ref(425)
    const leftDistance = ref(null)
    const cardAuth = ref(null)
    const cardHtml = computed(() => {
        if (null != props["cardList"] && Array.isArray(props["cardList"]) && currIndex.value < props["cardList"].length){
            return props["cardList"][currIndex.value].cardinfodesign
        }else{
            return ""
        }
    })

    const currIndex = ref(0)

    const cardHeight = ref("unset")

    watch(() => props.cardIndex, (newValue, oldValue) => {
        currIndex.value = props.cardIndex
        changeIndex()
    });

    watch(() => props.cardList, (newValue, oldValue) => {
        changeIndex()
    });

    watch(currIndex, (newValue, oldValue) => {
        changeIndex()
    });

    const showPrevArrow = ref(false)
    const showNextArrow = ref(false)

    function changeIndex(){

        if (currIndex.value > 0){
            showPrevArrow.value = true
        }else{
            showPrevArrow.value = false
        }

        if (null != props["cardList"] && Array.isArray(props["cardList"]) && currIndex.value < props["cardList"].length - 1){
            showNextArrow.value = true
        }else{
            showNextArrow.value = false
        }
    }

    function prevCard() {
        if (currIndex.value > 0){
            currIndex.value -= 1
            emits("changeIndex", currIndex.value)
        }

    }

    function nextCard() {
        if (null != props["cardList"] && Array.isArray(props["cardList"]) && currIndex.value < props["cardList"].length - 1){
            currIndex.value += 1
            emits("changeIndex", currIndex.value)
        }

    }

    function changePercent(percent){
        if (percent == 1){
            cardHeight.value = "unset"
        }else{
            cardHeight.value = `${Math.floor(275 * percent)}px`
        }
    }

    function clickCardImg(){
       // goCardView(props.cardList[props.cardIndex].id)
      goCardPage()
    }

    function goCardPage(){
        //location.href
          var url  = `${proxy.$ShopopeeUrl}receive?isAllow=1&id=${props["cardList"][currIndex.value].id}`

         myUtil.goURLNewWindow(url, "receive")
    }

    onMounted(() => {
        bannerWidth.value = proxy.$refs.mycardBanner.offsetWidth

        if (bannerWidth.value > 768){
          console.log(bannerWidth.value)
        }else{
            scaleWidth.value = bannerWidth.value - 20
            leftDistance.value = 10
        }

        if (null != props.cardIndex){
            currIndex.value = props.cardIndex
        }

        changeIndex()
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
        position: relative;
        min-height: 50px;
    }

    .full-width-mobile {
        width: 100%;
        position: relative;
        min-height: 50px;
        margin-top: 50px;
    }

    .card-div {
        margin: auto;
    }

    .card-div-mobile {
        margin: auto;
        margin-bottom: 60px;
    }

    .angle-part-div {
        width: 100px;
        height: 275px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 36px;
    }

    .left-angle {
        position: absolute;
        top: 0;
        left: 0;
    }

    .right-angle {
        position: absolute;
        top: 0;
        right: 0;
    }

    .angle-part-div-mobile {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .left-angle-mobile {
        position: absolute;
        bottom: -50px;
        left: 0;
    }

    .right-angle-mobile {
        position: absolute;
        bottom: -50px;
        right: 0;
    }

    .angle-part-div:hover,.angle-part-div-mobile:hover {
        background-color: #EEEEEE;
    }
</style>